import { routerMiddleware } from 'connected-react-router';
import { persistStore, persistReducer } from 'redux-persist';
import { CookieStorage } from 'redux-persist-cookie-storage';
import { all } from 'redux-saga/effects';
import { createBrowserHistory } from 'history';
import Cookies from 'cookies-js';

import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import { IS_DEV } from 'lib/constants';
import * as featureSagas from 'features/sagas';
import * as moduleSagas from './sagas';
import createRootReducer from './createRootReducer';

function* rootSaga() {
  yield all(
    Object.values(moduleSagas)
      .map((saga) => saga())
      .concat(Object.values(featureSagas).map((saga) => saga())),
  );
}

export const history = createBrowserHistory();

export default function createStore() {
  const sagaMiddleware = createSagaMiddleware();
  const middleware = [sagaMiddleware, routerMiddleware(history)];
  const rootReducer = persistReducer(
    {
      key: 'skymentalbiz',
      storage: new CookieStorage(Cookies, {
        expiration: { default: 365 * 86400 },
      }),
      whitelist: ['accounts'],
    },
    createRootReducer(history),
  );

  const store = configureStore({
    reducer: rootReducer,
    middleware,
    devTools: IS_DEV,
  });
  const persistor = persistStore(store, {});

  sagaMiddleware.run(rootSaga);

  return { store, persistor };
}
